/** Matches {@link CourseMaterialsDataModuleLessonItem} `contentSummary.typeName` for injected placeholder items. */
export const ADAPTIVE_AI_GENERATED_ITEM_TYPE = 'ai-generated' as const;
